import { render, staticRenderFns } from "./VarientModal.vue?vue&type=template&id=473fce16"
import script from "./VarientModal.vue?vue&type=script&lang=js"
export * from "./VarientModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports